import { render, staticRenderFns } from "./DistrictsPassport.vue?vue&type=template&id=4f8727f6"
import script from "./DistrictsPassport.vue?vue&type=script&lang=js"
export * from "./DistrictsPassport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports